const t = "_content_3anxe_1", o = {
  content: t,
  "arrow--top": "_arrow--top_3anxe_12",
  "arrow--bottom": "_arrow--bottom_3anxe_20",
  "arrow--left": "_arrow--left_3anxe_28",
  "arrow--right": "_arrow--right_3anxe_36"
};
export {
  t as content,
  o as default
};
//# sourceMappingURL=index.es442.js.map
